import {Component, inject} from '@angular/core';
import {LocalStorageService} from "../../_services/local-storage.service";
import {Title} from "@angular/platform-browser";
import {Community} from "../../_types/communities";
import {ActivatedRoute} from "@angular/router";
import {ContentService} from "../../_services/content.service";

@Component({
    selector: 'app-community-dynamic-page',
    templateUrl: './community-dynamic-page.component.html',
    styleUrl: './community-dynamic-page.component.scss'
})
export class CommunityDynamicPageComponent {
    content: any;
    title: string = 'Info'
    images: any[] = [];
    private readonly localStorageService: LocalStorageService = inject(LocalStorageService);

    constructor(private route: ActivatedRoute, private contentService: ContentService, private titleService: Title) {
        this.route.params
            .subscribe(params => {
                let community: Community | null = this.lastSelectedCommunity
                if (community?.id && params['id']) {
                    this.contentService.getCommunityPage(community?.id, params['id']).subscribe(r => {
                        this.title = r.title
                        this.titleService.setTitle(r.title);
                        this.content = r.content_text_rendered || r.content || '';
                        this.images = r.images;
                    })
                }
            });
    }

    get lastSelectedCommunity(): Community | null {
        return this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null);
    }
}
